module.exports = __webpack_public_path__ + "static/media/caminho-110.3a2578cb.png";